import { Model } from "@vuex-orm/core";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Company from "./Company";
import Industry from "./Industry";
import User from "./User";
import WorkOrder from "./WorkOrder";
import { ProjectAttachment } from "./Attachment";
import ProjectMaterial from "./ProjectMaterial";
import ProjectTag from "./ProjectTag";

export default class Project extends Model {
  
  static entity = 'projects';

  static $fetchActive() {
    return this.api().get('Projects/?archived=false')
  }
  static $fetchAll() {
    return this.api().get('Projects/')
  }
  static $get (id) {
    return this.api().get(`Projects/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Projects/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Projects/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`Projects/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      forgeID: this.string("FN"),
      name: this.string(""),
      icon: this.string("fas fa-box-open"),
      created: this.string(""),
      richtext: this.string(""),
      due_on: this.string(""),
      po_on: this.string(""),
      lastmodified: this.string(""),
      material_on: this.string(""),
      invoiceable: this.boolean(true),
      commercial: this.boolean(true),
      grant: this.boolean(false),
      archived: this.boolean(false),
      company_id: this.attr(null),
      company: this.belongsTo(Company, "company_id"),
      user_id: this.attr(null),
      user: this.belongsTo(User, "user_id"),
      BDuser_id: this.attr(null),
      BDuser: this.belongsTo(User, "BDuser_id"),
      tag: this.belongsTo(ProjectTag, "tag_id"),
      tag_id: this.attr(null),
      industry_id: this.attr(null),
      industry: this.belongsTo(Industry, "industry_id"),
      children: this.hasMany(WorkOrder, "project_id"),
      attachments: this.hasMany(ProjectAttachment, "project_id"),
      materials: this.hasMany(ProjectMaterial, "project_id")
    };
  }
  static get validations() {
    return {
      formdata: {
        forgeID: { required, maxLength: maxLength(16), minLength: minLength(6) },
        name: { required, maxLength: maxLength(124) },
        company_id: { required },
        user_id: { required },
        BDuser_id: { required },
        industry_id: { required }
      }
    };
  }
  getMaterialDate() {
    return new Date(this.material_on).toDateString();
  }
  getPODate() {
    return new Date(this.po_on).toDateString();
  }
  getDueDate() {
    return new Date(this.due_on).toDateString();
  }
  getLastModDate() {
    return new Date(this.lastmodified).toLocaleString("en-US", {timeZone: "America/Denver"});
  }
  getCreatedDate() {
    return new Date(this.created).toDateString();
  }
  getDaysTill() {
    //Get 1 day in milliseconds
    let one_day = 1000 * 60 * 60 * 24;
    let due_date = new Date(this.due_on);
    let today = new Date();
    // Convert both dates to milliseconds
    let date1_ms = due_date.getTime();
    let date2_ms = today.getTime();

    // Calculate the difference in milliseconds
    let difference_ms = date1_ms - date2_ms;

    // Convert back to days and return
    let days = Math.round(difference_ms / one_day);
    let colorText = "";
    let colorBase = "";
    if (days > 30) {
      colorText = "green--text text--darken-2";
      colorBase = "green darken-2";
    } else if (days < 30 && days > 7) {
      colorText = "orange--text text--darken-3";
      colorBase = "orange daren-3";
    } else {
      colorText = "red--text text--darken-3";
      colorBase = "red darken-3";
    }
    return { colorBase, colorText, days };
  }
  toCreatePayload() {
    return {
      forgeID: this.forgeID,
      name: this.name,
      invoiceable: this.invoiceable,
      commercial: this.commercial,
      grant: this.grant,
      company: this.company_id,
      user: this.user_id,
      BDuser: this.BDuser_id,
      industry: this.industry_id,
      archived: this.archived
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
}
